import { AnimatePresence, motion } from "framer-motion";
import { X } from "lucide-react";
import { useLang } from "@/i18n";

const DisclaimerModal = ({ open, onClose }) => {
  const { t } = useLang();
  const d = t.bio.disclaimer;

  return (
    <AnimatePresence>
      {open && (
        <div className="fixed inset-0 z-50 flex items-end justify-center sm:items-center" data-testid="disclaimer-modal">
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
            className="absolute inset-0 bg-black/70 backdrop-blur-sm"
          />
          <motion.div
            initial={{ opacity: 0, y: 64 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 64 }}
            transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
            className="relative max-h-[85vh] w-full max-w-2xl overflow-y-auto border border-white/10 bg-[#10161E] p-8 sm:p-12"
          >
            <button
              data-testid="disclaimer-close-button"
              onClick={onClose}
              aria-label="Close"
              className="absolute right-6 top-6 text-white/50 transition-colors hover:text-[#4A7BA6]"
            >
              <X size={22} />
            </button>
            <p className="font-tech text-xs uppercase tracking-[0.4em] text-[#4A7BA6]">Jano Automobili</p>
            <h3 className="mt-3 font-heritage text-3xl italic">{d.title}</h3>
            <p className="mt-8 text-base leading-relaxed text-neutral-400" data-testid="disclaimer-text-1">{d.p1}</p>
            <p className="mt-6 text-base leading-relaxed text-neutral-400" data-testid="disclaimer-text-2">{d.p2}</p>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
};

export default DisclaimerModal;
